// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"258b012d","535":"0608d08d","801":"10c49235"}[chunkId] + ".chunk.js";
};